import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "inputFile"]
  static values = { array: String }

  connect() {
  }

  displayFileName(event) {
    const originalText = 'Archivo adjunto';
    const input = event.currentTarget;
    const inputId = input.id;
    const fileType = JSON.parse(this.arrayValue)
    const label = document.querySelector(`label[for="${inputId}"]`);
    const errorMessage = input.closest('.input-container-form')?.querySelector('.error-message');
    const fileSize = input.files[0]?.size;

    // Verificamos si hay archivos seleccionados
    if (!input.files || input.files.length === 0) {
      label.textContent = originalText;
      return;
    }

    const fileName = input.files[0].name;
    const maxLength = 40;
    let truncatedFileName = fileName.length > maxLength ? fileName.substring(0, maxLength) + '...' : fileName;

    // Check if the file type received in the uploaded file is the same as the one in the fileType variable
    if (fileType) {
      const fileExtension = fileName.split('.').pop();
      const fileTypeMatch = fileType.find(type => type.toLowerCase() === fileExtension.toLowerCase());

      if (!fileTypeMatch) {
        errorMessage.textContent = `El archivo debe ser de tipo ${fileType.join(', ')}`;
        input.value = '';
        label.textContent = originalText;
        return;
      } else if (fileSize > 5000000) {
        errorMessage.textContent = 'El archivo debe pesar menos de 5MB';
        input.value = '';
        label.textContent = originalText;
        return;
      }

      if (fileName.length > maxLength) {
        truncatedFileName = fileName.substring(0, maxLength) + '...';
      }
      label.textContent = truncatedFileName;
      errorMessage.textContent = '';
    }
  }

  openFileDialog(event) {
    const id = this.inputFileTarget.children[0].children[0].id;
    var element = document.getElementById(id);

    if (event.target === event.currentTarget) {
      if(document.createEvent) {
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, true);
        element.dispatchEvent(evt);
      }
      else {
        element.click();
      }
    }
  }
}
